<template>
    <b-list-group-item class="lista-menu" @click.stop="abrirModal()"
        ><span>Informações TCU - SGTEC</span>
        <filtro ref="filtroModal"></filtro>
    </b-list-group-item>
</template>
<script>
import filtro from './RelacaoProjetoFiltro.vue'
export default {
    components: {
        filtro
    },

    methods: {
        abrirModal() {
            this.$refs.filtroModal.abrir()
        }
    }
}
</script>
